module.exports = __webpack_public_path__ + "static/customs-clearance-7c103c317b2a57d9688d25eba193c1d8.png";